import React, { useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import './style.scss';
import { IconSize, SvgIcon } from '../svgIcon';
import { icons } from 'constants/icons';

export type PaginationProps = {
  currentPage?: number;
  setCurrentPage: (page: number) => void;
  totalCount: number;
  perPageCount: number;
  // APIを呼ぶ関数
  fetchApi: () => void;
};

const MARGIN_PAGES_DISPLAYED_SIZE = 0; // 終端に表示する件数
const PAGE_RANGE_DISPLAYED_SIZE = 2; // 現在ページの前後に表示する件数

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  setCurrentPage,
  totalCount,
  perPageCount,
  fetchApi,
}) => {
  useEffect(() => {
    fetchApi();
  }, [currentPage]);

  const handlePaginate = (selectedItem: { selected: number }) => {
    setCurrentPage(selectedItem.selected + 1);
  };

  const pageCount = perPageCount ? Math.ceil(totalCount / perPageCount) : 1;

  return (
    <div className="pagination_wrapper">
      <span
        className={`pagination_wrapper_startLastLabel ${currentPage === 1 ? 'pagination__disabled' : ''}`}
        onClick={() => setCurrentPage(1)}
      >
        <SvgIcon icon={icons.leftleft} size={IconSize.icon_m} />
      </span>
      <ReactPaginate
        forcePage={currentPage ? currentPage - 1 : 0}
        pageCount={pageCount || 1}
        pageRangeDisplayed={PAGE_RANGE_DISPLAYED_SIZE}
        marginPagesDisplayed={MARGIN_PAGES_DISPLAYED_SIZE}
        breakLabel={''}
        onPageChange={handlePaginate}
        // ラベル
        previousLabel={<SvgIcon icon={icons.left} size={IconSize.icon_m} />}
        nextLabel={<SvgIcon icon={icons.right} size={IconSize.icon_m} />}
        // CSS系
        containerClassName={'pagination'}
        pageClassName={'pages pagination'}
        activeClassName={'active'}
        previousClassName={'pagination__previous'}
        nextClassName={'pagination__next'}
        breakClassName={'pagination__break'}
        disabledClassName={'pagination__disabled'}
      />
      <span
        className={`pagination_wrapper_startLastLabel ${pageCount <= (currentPage || 1) ? 'pagination__disabled' : ''}`}
        onClick={() => setCurrentPage(pageCount)}
      >
        <SvgIcon icon={icons.rightright} size={IconSize.icon_m} />
      </span>
    </div>
  );
};
